import React from "react";

export default function AlurPeminjamanTextIndividu(){
    return(
        <div className='alur-peminjaman-text'>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-one.png')} alt='number1'/>
                <span>Peminjam mengajukan permohonan pinjaman secara online melalui website Danai.id atau aplikasi mobile.</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-two.png')} alt='number2'/>
                <span>Danai.id akan memproses dan mengirimkan informasi pinjaman ke Perusahaan tempat Peminjam bekerja</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-three.png')} alt='number3'/>
                <span>Melakukan validasi data & memberikan konfirmasi kepada Danai.id</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-four.png')} alt='number4'/>
                <span>Pengajuan pinjaman akan tampil di <em>market place</em> Danai.id</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-five.png')} alt='number5'/>
                <span>Pemberi pinjaman dapat menentukan pinjaman yang akan didanai sesuai dengan preferensi</span>
            </div>
            <div className='list'>
                <img src={require('../../../../assets/img/product/number-six.png')} alt='number6'/>
                <span>Setelah dana terpenuhi, Danai.id akan mentransfer dana ke rekening Peminjam ke rekening yang telah terdaftar dan Peminjam dapat menggunakan dana tersebut</span>
            </div>
        </div>
    );
}